var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"error-message"},[_c('h4',{staticClass:"subtitle"},[_vm._v("An error occurred.")]),_c('Emote',{attrs:{"emote":'😅',"size":40}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }